type Cache = {
  [key: string]: {
    lastCall: number;
    promise: Promise<unknown>;
  };
};

export const createCache = () => {
  const cache: Cache = {};

  return {
    setCache: (key: string, promise: Promise<unknown>) => {
      cache[key] = {
        lastCall: new Date().getTime(),
        promise,
      };
    },
    getCache: (key: string) => {
      return cache[key]?.promise || null;
    },
    hasValidCache: (key: string, timeout = 60) => {
      return (
        cache[key] &&
        cache[key].lastCall > new Date().getTime() - timeout * 1000
      );
    },
  };
};
